import tippy from 'tippy.js'
import 'www/doctors.blocks/common/tippy-tooltip/tippy-tooltip.scss'

let tooltips = []

function initTooltips() {
  if (tooltips.length) {
    tooltips.forEach(t => t.destroy())
  }

  tooltips = tippy('[data-tooltip-title]', {
    allowHTML: true,
    placement: 'left',
    trigger: 'mouseenter',
    offset: [0, 4],
    theme: 'pd-dark-light',
    content(el) {
      return `
        <div class="text-caption text-no-wrap">
          ${el.dataset.tooltipTitle}
        </div>
      `
    },
  })
}

export default initTooltips
